import axios from 'axios';

import cfac22 from '../cfac22';

export default function approvalPhoto(campaignId, photoId, approval) {
  return new Promise((resolve, reject) => {
    Promise.resolve().
    then(() => {
      const config = {
        method: 'post',
        url: cfac22('API_HOST_V2') + '/campaignPolls/approvalPhoto',
        headers: {

          'Content-Type': 'application/json',
          'Full-Url': window.location.href
        },
        data: {
          campaignId: campaignId,
          photoId: photoId,
          approval: approval
        }, withCredentials: true
      };

      axios(config).
      then((result) => {
        resolve(result.data);
      }).
      catch((error) => {
        return reject(error.data.response);
      });
    }).
    catch((error) => {
      reject(error.response.data);
    });
  });
}
